//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-facet',
  inject: ['toggleFacets', 'showFacetCount'],
  props: {
    dataMntName: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
    active: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Array],
      default: '',
    },
    disabledIfEmpty: {
      type: Boolean,
      default: false,
    },
    appliedFacets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isHover: false,
    }
  },
  computed: {
    dataMntContent() {
      return this.label?.toLowerCase().replace(/\s+/g, '-')
    },
    disabled() {
      return this.count === 0
    },
    dynamicIcon() {
      return this.active ? `${this.icon}-light` : this.icon
    },
    isActive() {
      return (
        this.active ||
        this.appliedFacets.some((filter) => {
          return filter === this.value
        })
      )
    },
  },
  methods: {
    labelToShow(label) {
      const rg = new RegExp(/([a-zA-Z])\.([a-zA-Z])/)
      return rg.test(label) ? this.$t(label) : label
    },
    onFacetClick() {
      if (this.count === 0) {
        return
      }
      this.toggleFacets(Array.isArray(this.value) ? this.value : [this.value])
    },
  },
}
